import { Injectable } from '@angular/core';
import {Headers, Http, Response} from "@angular/http";
import {Observable} from "rxjs/Observable";
import {Subject} from "rxjs/Subject";
import {ConnectionService} from "./connection.service";
import {EmailAccount} from "../entities/EmailAccount";
import {SessionService} from "./session.service";
import {AppConfig} from "../app.config";
import { AzureLogin } from 'app/entities/AzureLogin';

@Injectable()
export class LoginService {
  requestString: string;
  userNo: string;
  params: string;
  feedback: { access_token: string};

  private readonly apiUrl: string;
  private headers: Headers;

  public loggedSubject : Subject<boolean>;
  public isLogged : any;

  constructor(private http: Http,
              private sessionService: SessionService,
              private connectionService: ConnectionService,
              private config: AppConfig) {
    this.apiUrl = config.getConfig('endPointApiUrl');
    this.feedback = {access_token : ''};

    this.loggedSubject = new Subject<boolean>();
    this.isLogged = this.loggedSubject.asObservable();
    this.loggedSubject.next(false);
  }

  login(emailAccount : EmailAccount): Observable<any>
  {
    this.params = JSON.stringify(emailAccount);

    return this.http.post(this.apiUrl + "api/Contact/Login",
      JSON.stringify(emailAccount), {
      headers: this.connectionService.GetAuthorizationHeader() } )
      .map((resp: Response): void => {
        const feedback = resp.json();
        this.feedback = feedback;
        this.loggedSubject.next(true);
        this.userNo = emailAccount.username;
        
      });
  }

  loginWithAzureAdAccount(azureLogin: AzureLogin): Observable<any>
  {
    return this.http.post(this.apiUrl + "api/Contact/LoginWithAzureAd",
      JSON.stringify(azureLogin), {

      headers: this.connectionService.GetAuthorizationHeader()})
      .map((response: Response) => response.json())
  }

  exchangeAuthorizationCodeForToken(tokenEndpoint: string, requestObject: any): Observable<any>
  {
    this.requestString = "grant_type=authorization_code" +
      "&client_id=" + encodeURIComponent(requestObject.client_id) +
      "&redirect_uri=" + encodeURIComponent(requestObject.redirect_uri) +
      "&code_verifier=" + encodeURIComponent(requestObject.code_verifier) +
      "&code=" + encodeURIComponent(requestObject.code);

    this.headers = new Headers();
    this.headers.append("Content-Type", "application/x-www-form-urlencoded");
    this.headers.append("Accept", "application/json");

    return this.http.post(tokenEndpoint, this.requestString, {
      headers: this.headers
    }).map((resp: Response) => resp.json());
  }

  getSalesPersonNoFromEntraToken(accessToken: string): Observable<string>
  {
    let url = this.apiUrl + "api/SalesPerson/GetSalesPersonByEmail";
    return this.http.get(url, {
      headers: this.connectionService.GetAuthorizationHeaderFromToken(accessToken)
    }).map((response: Response) => response.json().userNo);
  }

  getLoggedInUserToken()
  {
    return this.feedback;
  }

  setSession(isAdmin : boolean): Observable<boolean>
  {
    return this.sessionService.setSession(this.feedback.access_token, this.userNo, isAdmin);
  }

  logout(): void
  {
    this.sessionService.logout();
    this.loggedSubject.next(false);
  }

  getLoggedInUserID(): string
  {
    return sessionStorage.getItem('userNo');
  }

  isLoggedIn(): boolean
  {
    return (sessionStorage.getItem('token') != null && sessionStorage.getItem('token') != '');
  }

  isAdmin(): boolean
  {
    return sessionStorage.getItem('isAdmin') == 'true';
  }

  checkAccessToken()
  {
    return this.isLogged;
  }

  getCompanies(): Observable<any>
  {
    let url = this.apiUrl + 'api/Contact/GetCompanies';
    return this.http
      .get(url, {headers: this.headers})
      .map(response => response.json() as any[]);
  }

}





// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/services/login.service.ts